import React, { useEffect } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import StaffForm from './StaffForm';
import { createStaff, clearMessages } from '../../slices/staff';
import _  from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

const AddStaff = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { successMsg, errorMsg } = useSelector(state => state.staff);
    const handleSubmit = (data) => {
        const {
            name,
            email,
            role,
            password,
            mobile
        } = data    
        dispatch(createStaff({name, email, role, password, mobile}))        
    }
    useEffect(() => {
        if (!!errorMsg) {
            toast.error(errorMsg, {
                position: 'top-center'
            })
        }
        if (!!successMsg) {
            toast.success(successMsg, {
                position: 'top-center'
            })
            navigate('/manage-staff')
        }
        dispatch(clearMessages());
    }, [successMsg, errorMsg]);
  return (
    <Container>
    <Row>
        <Col xl={12} lg={12}>
            <Card>
                <Card.Header className="d-flex justify-content-between">
                    <div className="header-title">
                        <h4 className="card-title">Create Staff</h4>
                    </div>
                </Card.Header>
                <Card.Body>
                    <StaffForm submitFunc={handleSubmit}/>
                </Card.Body>
            </Card>
        </Col>
    </Row>
    
    </Container>
  )
}

export default AddStaff
